export { default } from './UserRatingService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userRating/services/UserRatingService/index.js